<template>
    <div>
        <div class="gap-bottom-equal  edu-about-area about-style-1  bg-lighten04">
            <div class="container edublink-animated-shape">
                <div class="row g-5 align-items-center">
                    <div class="col-lg-12">
                        <SectionTitle 
                            preTitle="香港基督徒中樂團" 
                            title='基中曲目' 
                            subTitle=''
                        />
                        <vue-good-table :columns="columns" :rows="rows">                        
                            <!-- Custom cell rendering -->
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'YouTube'">
                                    <a v-if="props.row.YouTube"
                                        :href="props.row.YouTube"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <!-- Inline YouTube SVG -->
                                        <svg xmlns="http://www.w3.org/2000/svg" 
                                            width="24" height="24" viewBox="0 0 24 24" 
                                            fill="red">
                                        <path d="M23.498 6.186a2.974 2.974 0 0 0-2.096-2.103C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.402.583a2.974 2.974 0 0 0-2.096 2.103C0 8.09 0 12 0 12s0 3.91.502 5.814a2.974 2.974 0 0 0 2.096 2.103C4.5 20.5 12 20.5 12 20.5s7.5 0 9.402-.583a2.974 2.974 0 0 0 2.096-2.103C24 15.91 24 12 24 12s0-3.91-.502-5.814zM9.75 15.568V8.432L15.818 12 9.75 15.568z"/>
                                        </svg>
                                    </a>
                                    <!--
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <i class="fab fa-youtube" style="color:red; font-size:20px;">qqqq</i>
                                    </a>
                                    -->
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>       

                    <!--
                    <div class="col-lg-2">
                        <div class="about-image-gallery">
                            <img class="main-img-1" src="/images/hkcco/ewu.webp" alt="About Image">
                        </div>
                    </div>
                    -->

                </div>
                <ul class="shape-group">
                    <!-- <MouseMove addClassName="shape-1 circle" dataDepth="-2.3" data-aos-delay="500" data-aos="fade" data-aos-duration="200" /> -->
                </ul>
            </div>
        </div>
    </div>

</template>

<script>

    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import { VueGoodTable } from "vue-good-table";
    import 'vue-good-table/dist/vue-good-table.css';

    export default {

        components: {
            SectionTitle: () => import('@/components/common/SectionTitle'),
            VueGoodTable 
        },

        mounted() {
            AOS.init();
            this.loadJsonData();
        },       

        data () {
            return {
                //columns: [],
                columns: [
                    { label: '', field: 'YouTube' }, // no header text
                    { label: '類別1', field: '類別' },
                    { label: '曲目', field: '曲目' },
                    { label: '作者/編者', field: '作者/編者' },
                    { label: '歌曲風格及簡介', field: '歌曲風格及簡介' }
                ],
                rows: [],
            }
        },

        methods: {
            async loadJsonData() {
                try {
                    const response = await fetch("/data/songsdata.json"); 
                    const jsonData = await response.json();

                    console.log('jsonData')
                    console.log(jsonData)

                    this.columns = Object.keys(jsonData[0]).map((header) => ({
                        label: header,
                        field: header
                    }));

                    this.rows = jsonData;
                } catch (error) {
                    console.error("Error loading JSON:", error);
                }
            }
        },
    
    }

</script>

<!-- Add Font Awesome for YouTube icon 
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"/>
-->
